import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react'; // import { TrackerProps } from '../../utils/tracking';

import { View } from 'react-native';
import { Button } from '../../Button/rn';
import * as RNStyle from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export var ButtonGroup = function ButtonGroup(props) {
  var _buttons$filter;
  var _id = props._id,
    buttons = props.buttons,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    _props$hide = props.hide,
    hide = _props$hide === void 0 ? false : _props$hide,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$styles = props.styles,
    stylesProps = _props$styles === void 0 ? {} : _props$styles;
  var showButton = Boolean((buttons === null || buttons === void 0 ? void 0 : buttons.length) && !hide);
  var getButtonStyle = function getButtonStyle(buttonProps, index) {
    var _buttonProps$styles;
    var isDefaultButton = buttonProps.type === 'default' || !buttonProps.type;
    var borderStyle = index < buttons.length - 1 && isDefaultButton && layout === 'horizontal' ? {
      borderRightWidth: 0.5,
      borderRightStyle: 'solid',
      borderRightColor: RNStyle.gray_6
    } : {};
    return {
      containerStyle: _objectSpread(_objectSpread(_objectSpread({
        minWidth: layout === 'horizontal' ? 'auto' : undefined
      }, layout === 'horizontal' ? {
        flex: 1
      } : {}), borderStyle), ((_buttonProps$styles = buttonProps.styles) === null || _buttonProps$styles === void 0 ? void 0 : _buttonProps$styles.containerStyle) || {})
    };
  };
  return /*#__PURE__*/React.createElement(View, {
    style: [styles["button-group__".concat(layout)], stylesProps]
  }, showButton && (buttons === null || buttons === void 0 ? void 0 : (_buttons$filter = buttons.filter(function (btn) {
    return !btn.hidden;
  })) === null || _buttons$filter === void 0 ? void 0 : _buttons$filter.map(function (button, index) {
    return /*#__PURE__*/React.createElement(Button, _extends({
      _id: _id,
      disabled: disabled,
      key: index
    }, button, {
      styles: _objectSpread(_objectSpread({}, button.styles), getButtonStyle(button, index))
    }));
  })));
};
var styles = CustomStyleSheet({
  // .@{prefix-cls}-button-group {
  //     &__vertical {
  //       width: 100%;
  //     }
  //     &__horizontal {
  //       display: flex;
  //       flex-direction: row;
  //       .@{prefix-cls}-button {
  //         min-width: unset;
  //       }
  //     }
  //   }
  'button-group__vertical': {
    width: '100%'
  },
  'button-group__horizontal': {
    flexDirection: 'row'
  }
});